export const IP_TELMEX_GET_COUNTER_VALID_EMAIL = 'GET_COUNTER_VALID_EMAIL';
export const IP_TELMEX_UPDATE_EMAIL = 'IP_TELMEX_UPDATE_EMAIL';
export const IP_TELMEX_UPDATE_EMAIL_OPEN_MODAL = 'IP_TELMEX_UPDATE_EMAIL_OPEN_MODAL';
export const IP_TELMEX_UPDATE_EMAIL_CLOSE_MODAL = 'IP_TELMEX_UPDATE_EMAIL_CLOSE_MODAL';
export const IP_TELMEX_SET_ERROR = 'IP_TELMEX_SET_ERROR';
export const IP_TELMEX_SET_LOADING = 'IP_TELMEX_SET_LOADING';
export const IP_TELMEX_SET_PHONE = 'IP_TELMEX_SET_PHONE';
